import Vue from "vue";
import AOS from "aos";
import VModal from 'vue-js-modal';
import { screens } from '../../../tailwind';
import lineClamp from 'vue-line-clamp'
import VueKonva from 'vue-konva'

Vue.use(lineClamp, {
  importCss: true
})

Vue.use(VueKonva)
Vue.use(VModal)

AOS.init({
  once: true,
  disable: 'mobile',
})

const files = require.context("./components/", true, /\.vue$/i);
files.keys().map(key =>
  Vue.component(
    key
      .split("/")
      .pop()
      .split(".")[0],
    files(key).default
  )
);

let isScrollable = true;

if(window.matchMedia(`(min-width: ${ screens.md })`).matches) {
  isScrollable = false;
}

new Vue({
  el: "#app",
  data: {
    isModalScrollable: isScrollable
  }
});
